export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5547991654435?text=Ol%C3%A1%20Jennifer%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio!"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-primary-500 hover:bg-primary-400 text-background-950 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
      aria-label="Agendar via WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl md:text-3xl w-6 h-6 md:w-7 md:h-7 flex items-center justify-center"></i>
    </a>
  );
}